export default __webpack_public_path__ + "static/productrec-fefe0c4b5f3d0106cdaf3e8668cc81f8.mp4";